
import API from '@/api'
import wx from 'weixin-js-sdk'
import config from '../config/index'

export { default as Qs } from 'qs'
export { default as Cookies } from 'js-cookie'


export const obj2qs = (obj, isAddEmpty) => {
  obj = obj || {}
  let qs = '?'
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    if (key && (isAddEmpty || value)) {
      if (qs.length !== 1) {
        qs += '&'
      }
      qs += `${key}=${value}`
    }
  })

  return qs.length > 1 ? qs : ''
}

export function parseQuery(queryString = '') {
  const params = {}
  const idx = queryString.indexOf('?')
  if (idx > -1) {
    queryString = queryString.slice(idx + 1)
  } else {
    queryString = ''
  }
  if (queryString) {
    queryString = queryString.split('&')
    let i; let l; let q; let key; let
      value
    for (i = 0, l = queryString.length; i < l; i += 1) {
      q = queryString[i]
      q = q.split('=')
      key = decodeURIComponent(q[0])
      value = decodeURIComponent(q[1])
      params[key] = value
    }
  }
  return params
}

export function addUrlParams(url, obj) {
  let result = url.split('?')[0]
  const paramObj = parseQuery(url)

  result += obj2qs(
    {
      ...paramObj,
      ...obj,
    },
    result.includes('?') ? '&' : '?',
  )

  return result
}

export function removeUriParams(uri, arr) {
  const o = parseQuery(uri)
  const path = uri.split('?')[0]

  arr.forEach((key) => {
    delete o[key]
  })

  return `${path}${obj2qs(o)}`
}

export function platform() {
  const ua = navigator.userAgent
  const isWX = ua.match(/MicroMessenger\/([\d.]+)/)
  const isQQ = ua.match(/QQ\/([\d.]+)/)
  const isQZ = ua.indexOf('Qzone/') !== -1
  if (isWX || isQQ || isQZ) {
    return true
  }
  return false
}

/**
 * 判断浏览器类型
 * @param name
 * iphone
 * android
 * micromessenger
 * @returns {boolean}
 */
export function isBrower(name) {
  const UA = window.navigator.userAgent.toLowerCase()
  return UA.indexOf(name) > -1
}

export function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase()
  if (/[M m]icroMessenger/i.test(ua)) {
    return true
  }
  return false
}

/**
 *
 * 摘自vue-wechat-title
 * https://github.com/deboyblog/vue-wechat-title
 *
 */
export function setWechatTitle(title, src = '/iframe.html') {
  if (title === undefined || window.document.title === title) {
    return
  }
  document.title = title
  const mobile = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(mobile)) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.setAttribute('src', src)
    const iframeCallback = () => {
      setTimeout(() => {
        iframe.removeEventListener('load', iframeCallback)
        document.body.removeChild(iframe)
      }, 0)
    }
    iframe.addEventListener('load', iframeCallback)
    document.body.appendChild(iframe)
  }
}

const h5Global = {}
export {
  h5Global,
}


export function getUID(length) {
  if (typeof length === 'undefined') {
    length = 10
  }

  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let name = ''
  let i = 0

  while (i < length) {
    name += chars[Math.floor(Math.random() * (chars.length - 1) + 1)]
    i += 1
  }

  return name
}

export const getSession = (key) => {
  try {
    return sessionStorage[`${key}`] || ''
  } catch (err) {
    return window.GLOBAL_DATA[`${key}`] || ''
  }
}

export const setSession = (key, value) => {
  try {
    const old = getSession(key)
    if (old !== value) {
      sessionStorage[`${key}`] = typeof value === 'string' ? value : JSON.stringify(value)
    }
  } catch (err) {
    window.GLOBAL_DATA[`${key}`] = value
  }
}


export const getLocalSession = (key) => {
  const res = localStorage[`${key}`]
  return res ? JSON.parse(res) : null
}

export const setLocalSession = (key, value) => {
  try {
    const old = getLocalSession(key)
    if (old !== value) {
      localStorage[`${key}`] = typeof value === 'string' ? value : JSON.stringify(value)
    }
  } catch (err) {
    window.GLOBAL_DATA[`${key}`] = value
  }
}

export const removeSession = (key) => {
  try {
    return sessionStorage.removeItem([`${key}`])
  } catch (err) {
    window.GLOBAL_DATA[`${key}`] = null
    return window.GLOBAL_DATA.remove(key)
  }
}

let wxReady = false

export const doWxAuth = (option = {}, cb = () => {}) => {
  const isWX = isWeiXin()
  if (isWX) {
    const url = window.location.href.split('#')[0]
    // encodeURIComponent(window.location.origin + to.fullPath) // spa 页面请求微信分享 url
    const params = {
      ...config.wxDefaultConfig,
      ...option,
      url: option.url || url,
      jsApiList: option.jsApiList || config.wxDefaultConfig.jsApiList,
    }
    API.getJsSdkConfig(params)
      .then((res) => {
        wx.config(res)
        wx.ready(() => {
          console.log('wx ready')
          wxReady = true
          cb()
        })
      })
      .catch(err => console.error(err))
  }
}

export const hideMenuItems = (menuList = []) => {
  const isWX = isWeiXin()
  if (isWX) {
    if (wxReady) {
      wx.hideMenuItems({ menuList })
      return
    }
    wx.ready(() => {
      wx.hideMenuItems({ menuList })
    })
  }
}

export const showMenuItems = (menuList = []) => {
  const isWX = isWeiXin()
  if (isWX) {
    if (wxReady) {
      wx.showMenuItems({ menuList })
      return
    }
    wx.ready(() => {
      wx.showMenuItems({ menuList })
    })
  }
}

export const refreshAuthToken = () => {
  removeSession('token')
  window.location.replace(
    `https://wx.knowyourself.cc/wechat/oauth?url=${encodeURIComponent(window.location.href)}&source=0`,
  )
}

export const getUserInfo = (token) => {
  console.log(token)
  return new Promise((resolve, reject) => {
    API.getWxUserInfo(token)
      .then((res) => {
        const {
          nickname, sex, city, language, headimgurl,
        } = res

        setSession('nickname', nickname)
        setSession('sex', sex)
        setSession('city', city)
        setSession('language', language)
        setSession('headimgurl', headimgurl)
        resolve(res)
      })
      .catch((err) => {
        console.error(err)
        reject(err)
      })
  })
}
